import ScrollReveal from 'scrollreveal';

let defaultCounter = 0;
let footer = document.querySelector('footer');

const slideUp = {
  delay: 350,
  distance: '125%',
  duration: 1150,
  easing: 'cubic-bezier(0.165, 0.85, 0.45, 1)',
  origin: 'bottom',
  reset: false
};

const slideUp500 = {
  delay: 500,
  distance: '125%',
  duration: 1150,
  easing: 'cubic-bezier(0.165, 0.85, 0.45, 1)',
  origin: 'bottom',
  reset: false
};

const slideUp600 = {
  delay: 600,
  distance: '125%',
  duration: 1150,
  easing: 'cubic-bezier(0.165, 0.85, 0.45, 1)',
  origin: 'bottom',
  reset: false
};

const slideUp700 = {
  delay: 700,
  distance: '125%',
  duration: 1150,
  easing: 'cubic-bezier(0.165, 0.85, 0.45, 1)',
  origin: 'bottom',
  reset: false
};

const slideUp800 = {
  delay: 800,
  distance: '125%',
  duration: 1150,
  easing: 'cubic-bezier(0.165, 0.85, 0.45, 1)',
  origin: 'bottom',
  reset: false
};

const slideUp900 = {
  delay: 900,
  distance: '125%',
  duration: 1150,
  easing: 'cubic-bezier(0.165, 0.85, 0.45, 1)',
  origin: 'bottom',
  reset: false
};

const slideUp1000 = {
  delay: 1000,
  distance: '125%',
  duration: 1150,
  easing: 'cubic-bezier(0.165, 0.85, 0.45, 1)',
  origin: 'bottom',
  reset: false
};

const slideUp1100 = {
  delay: 1100,
  distance: '125%',
  duration: 1150,
  easing: 'cubic-bezier(0.165, 0.85, 0.45, 1)',
  origin: 'bottom',
  reset: false
};

const slideUp1300 = {
  delay: 1300,
  distance: '125%',
  duration: 1150,
  easing: 'cubic-bezier(0.165, 0.85, 0.45, 1)',
  origin: 'bottom',
  reset: false
};

const slideUp1500 = {
  delay: 1500,
  distance: '125%',
  duration: 1150,
  easing: 'cubic-bezier(0.165, 0.85, 0.45, 1)',
  origin: 'bottom',
  reset: false
};

const slideLeft = {
  delay: 350,
  distance: '125%',
  duration: 1150,
  easing: 'cubic-bezier(0.165, 0.85, 0.45, 1)',
  origin: 'right',
  reset: false
};

const slideRight = {
  delay: 350,
  distance: '125%',
  duration: 1150,
  easing: 'cubic-bezier(0.165, 0.85, 0.45, 1)',
  origin: 'left',
  reset: false
};
if (window.screen.width > 959 || window.innerWidth > 959) {
  ScrollReveal().reveal('.slide-up', slideUp);
  ScrollReveal().reveal('.slide-up-500', slideUp500);
  ScrollReveal().reveal('.slide-up-600', slideUp600);
  ScrollReveal().reveal('.slide-up-700', slideUp700);
  ScrollReveal().reveal('.slide-up-800', slideUp800);
  ScrollReveal().reveal('.slide-up-900', slideUp900);
  ScrollReveal().reveal('.slide-up-1000', slideUp1000);
  ScrollReveal().reveal('.slide-pin-500', slideUp500);
  ScrollReveal().reveal('.slide-pin-700', slideUp700);
  ScrollReveal().reveal('.slide-pin-900', slideUp900);
  ScrollReveal().reveal('.slide-pin-text-1100', slideUp1100);
  ScrollReveal().reveal('.slide-pin-text-1300', slideUp1300);
  ScrollReveal().reveal('.slide-pin-text-1500', slideUp1500);
  ScrollReveal().reveal('.slide-left', slideLeft);
  ScrollReveal().reveal('.slide-right', slideRight);
}
document.addEventListener('scroll', () => {
  //startNumbersCounting();
  if(footer) {
    changeBgFooter();
  }
});
if(footer) {
  changeBgFooter();
}
function changeBgFooter() {
  if(window.pageYOffset > 350) {
    footer.classList.remove('unactive');
  } else {
    footer.classList.add('unactive');
  }
}

function startNumbersCounting() {
  const countingNumbers = document.querySelector('.map__company-progress');

  if (countingNumbers) {
    const oTop = $('.map__company-progress').offset().top - window.innerHeight;

    if (defaultCounter === 0 && $(window).scrollTop() > oTop) {
      $('.map__company-progress-point h2').each(function() {
        var $this = $(this),
          countTo = $this.attr('data-count');
        $({
          countNum: $this.text()
        }).animate({
          countNum: countTo
        },
        {
          duration: 2500,
          easing: 'linear',
          step: function() {
            $this.text(Math.floor(this.countNum));
          },
          complete: function() {
            if($this.parents('.number-plus').length) {
              $this.text(this.countNum).append('<span>+</span>');
            } else {
              $this.text(this.countNum);
            }
          }

        });
      });
      defaultCounter = 1;
    }
  }
}
